<template>
  <div class="content-container">
    <div class="content-wrapper">
      <h1>Боты Telegram</h1>

      <div class="fast-links">
        <router-link class="btn-add" to="/add-bot">
          <i class="bi bi-patch-plus"></i>
          <span>Добавить бота</span>
        </router-link>
      </div>

      <div class="bot-list-container">
        <div v-for="bot in listBots" :key="bot.id" class="bot-item-container">
          <div class="bot-info-top">
            <img src="../assets/img/bot_item_icon.svg" />
            <div class="bot-info-top-text">
              <span class="bot-item-title">@{{ bot.username }}</span>
              <span>{{ bot.token }}</span>
            </div>
          </div>

          <div class="bot-info-bottom">
            <div class="bot-info-bottom-item">
              <h2>{{ bot.subscribers_total }}</h2>
              <span>подписчиков<br />всего</span>
            </div>

            <div class="bot-info-bottom-item">
              <h2>{{ bot.subscribers_active }}</h2>
              <span>подписчиков<br />активных</span>
            </div>

            <div class="bot-info-bottom-item">
              <h2>{{ bot.posts_sent }}</h2>
              <span>отправлено<br />всего</span>
            </div>
          </div>

          <button class="btn-edit-welcome" @click="openWelcomeModal(bot)">
            ✏️ Приветствие
          </button>
        </div>
      </div>
    </div>

    <!-- ===================== МОДАЛКА ПРИВЕТСТВИЯ ===================== -->
    <div v-if="showWelcome" class="modal-overlay">
      <div class="modal-window">

        <h2>Приветственное сообщение @{{ currentBot?.username }}</h2>

        <div class="modal-scroll">

          <!-- === Editor === -->
          <div class="toolbar">
            <button @click.prevent="applyFormat('bold')"><b>B</b></button>
            <button @click.prevent="applyFormat('italic')"><i>I</i></button>
            <button @click.prevent="applyFormat('underline')"><u>U</u></button>
            <button @click.prevent="insertLink">🔗</button>
          </div>

          <div
              class="editable"
              ref="editor"
              contenteditable="true"
              @input="syncEditor"
              @blur="syncEditor"
              placeholder="Введите приветственное сообщение..."
          ></div>

          <div
              class="remaining-chars"
              :class="{ warn: remaining < 200, error: remaining < 0 }"
          >
            Символов: {{ jsLength }} / 1024
          </div>

          <!-- === Image === -->
          <div class="form-image">
            <input type="file" id="welcomeImage" style="display:none" @change="onImageChange" />

            <!-- Когда изображения НЕТ -->
            <div
                v-if="!welcomeImagePreview"
                class="image-empty"
                @click="openImageInput"
            >
              <span class="image-empty-text">Загрузить изображение</span>
            </div>

            <!-- Когда изображение ЕСТЬ -->
            <div v-else class="image-wrapper" @click="openImageInput">
              <img :src="welcomeImagePreview" class="image-preview"/>

              <div class="image-overlay">
                <span class="replace-text">Заменить изображение</span>
              </div>
            </div>
          </div>

          <!-- === Buttons === -->
          <div v-for="(button,i) in buttons" :key="i" class="form-buttons">
            <span>Кнопка {{ i+1 }}</span>
            <input class="form-buttons-text" v-model="button.text" placeholder="Текст" />
            <input class="form-buttons-text" v-model="button.link" placeholder="Ссылка" />
          </div>

          <button class="btn-add-button" @click="addButton">+ Добавить кнопку</button>

        </div>

        <!-- ACTIONS -->
        <div class="modal-actions">
          <button class="btn-primary" @click="saveWelcome" :disabled="invalid">Сохранить</button>
          <button class="btn-secondary" @click="closeWelcome">Отмена</button>
        </div>

        <div v-if="invalid" class="form-errors">
          <p v-for="err in validationErrors" :key="err">❌ {{ err }}</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "@/config";

export default {
  name: "Bots",

  data() {
    return {
      listBots: [],

      showWelcome: false,
      currentBot: null,

      welcomeText: "",
      welcomeHTML: "",
      jsLength: 0,
      remaining: 1024,

      welcomeImagePreview: "",
      welcomeImageValue: "",

      buttons: []
    };
  },

  async created() {
    await this.loadListBots();
  },

  computed: {
    invalid() {
      return (
          this.jsLength === 0 ||
          this.remaining < 0 ||
          this.buttons.some(b => !b.text?.trim() || !b.link?.trim() || !this.isValidUrl(b.link))
      );
    },

    validationErrors() {
      const e = [];
      if (this.jsLength === 0) e.push("Текст приветствия пустой");
      if (this.remaining < 0) e.push("Превышен лимит символов");
      if (this.buttons.some(b => !b.text?.trim() || !b.link?.trim()))
        e.push("Есть кнопки без текста или ссылки");
      if (this.buttons.some(b => !this.isValidUrl(b.link)))
        e.push("Некорректная ссылка");
      return e;
    }
  },

  methods: {
    async loadListBots() {
      this.listBots = await fetch(`${API_URL}/bots`).then(r => r.json());
    },

    openWelcomeModal(bot) {
      this.currentBot = bot;
      this.showWelcome = true;

      this.welcomeText = bot.welcome_text || "";

      // Кнопки
      try {
        const parsed = JSON.parse(bot.welcome_buttons || "[]");
        this.buttons = Array.isArray(parsed) ? parsed : [];
      } catch {
        this.buttons = [];
      }

      // Изображение
      this.welcomeImagePreview = bot.welcome_image
          ? `${API_URL}/static/${bot.welcome_image}`
          : "";

      this.$nextTick(() => {
        this.$refs.editor.innerHTML = this.welcomeText;
        this.syncEditor();
      });
    },

    closeWelcome() {
      this.showWelcome = false;
      this.currentBot = null;
      this.welcomeText = "";
      this.buttons = [];
      this.welcomeImagePreview = "";
      this.welcomeImageValue = "";
    },

    applyFormat(cmd) {
      this.$refs.editor.focus();
      document.execCommand(cmd, false, null);
      this.syncEditor();
    },

    insertLink() {
      const url = prompt("Введите ссылку:");
      if (!url) return;
      this.$refs.editor.focus();
      document.execCommand("createLink", false, url);
      this.syncEditor();
    },

    syncEditor() {
      const el = this.$refs.editor;
      this.welcomeHTML = el.innerHTML;
      const txt = el.innerText.trim();

      this.welcomeText = txt;
      this.jsLength = txt.length;
      this.remaining = 1024 - txt.length;
    },

    // IMAGE
    openImageInput() {
      document.getElementById("welcomeImage").click();
    },

    onImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onloadend = () => {
        this.welcomeImagePreview = reader.result;
        this.welcomeImageValue = reader.result.replace("data:", "").replace(/^.+,/, "");
      };
      reader.readAsDataURL(file);
    },

    addButton() {
      this.buttons.push({ text: "", link: "" });
    },

    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    },

    cleanHtml(html) {
      let cleaned = html;
      cleaned = cleaned.replace(/<div[^>]*>/g, "\n").replace(/<\/div>/g, "");
      cleaned = cleaned.replace(/<br[^>]*>/g, "\n");
      cleaned = cleaned.replace(/<(?!\/?(b|strong|i|em|u|s|a)(\s|>|\/))/gi, "");
      cleaned = cleaned.replace(/<(?!a\b)([a-z]+)\s+[^>]*>/gi, "<$1>");
      return cleaned.trim();
    },

    async saveWelcome() {
      const payload = {
        welcome_text: this.cleanHtml(this.welcomeHTML),
        welcome_image: this.welcomeImageValue,
        welcome_buttons: this.buttons
      };

      await fetch(`${API_URL}/bots/${this.currentBot.id}/welcome`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      this.closeWelcome();
      await this.loadListBots();
    }
  }
};
</script>

<style scoped>

/* ====================== LAYOUT ====================== */
.content-container {
  display: flex;
  padding: 20px;
}

.content-wrapper {
  width: 100%;
  max-width: 900px;
}

h1 {
  margin-bottom: 20px;
  font-size: 26px;
  font-weight: 700;
}

/* ====================== BOT LIST ====================== */

.bot-list-container {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.bot-item-container {
  background: #ffffff;
  border: 1px solid #e1e4ea;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: 0.2s ease;
}

.bot-item-container:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.07);
}

.bot-info-top {
  display: flex;
  gap: 10px;
  align-items: center;
}

.bot-info-top img {
  width: 42px;
}

.bot-info-top-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
}

.bot-item-title {
  font-size: 17px;
  font-weight: 600;
}

.bot-info-bottom {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.bot-info-bottom-item {
  text-align: center;
}

.bot-info-bottom-item h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
}

.bot-info-bottom-item span {
  font-size: 12px;
  color: #777;
  line-height: 14px;
}

/* === Приветствие кнопка === */

.btn-edit-welcome {
  margin-top: auto;
  width: 100%;
  padding: 10px 0;
  background: #2ecc71;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}

.btn-edit-welcome:hover {
  background: #28c466;
}

/* ====================== MODAL ====================== */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-window {
  width: 520px;
  max-height: 90vh;
  background: white;
  border-radius: 14px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  animation: popup 0.2s ease-out;
}

@keyframes popup {
  from { opacity:0; transform: scale(0.9); }
  to   { opacity:1; transform: scale(1); }
}

/* === SKROLL === */
.modal-scroll {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 4px;
}

/* ====================== EDITOR (как Sender.vue) ====================== */

.toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 6px;
}

.toolbar button {
  background: #f7f9fc;
  border: 1px solid #d5dce5;
  padding: 4px 10px;
  border-radius: 5px;
}

.toolbar button:hover {
  background: #eef3fa;
  border-color: #c3d1e3;
}

.editable {
  min-height: 140px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: white;
  outline: none;
  font-size: 15px;
  line-height: 1.4;
  resize: vertical;
  white-space: pre-wrap;
}

.editable a {
  color: #2980b9;
  text-decoration: underline;
}

.editable:empty:before {
  content: attr(placeholder);
  color: #aaa;
}

.remaining-chars {
  font-size: 12px;
  margin-top: 5px;
  color: #777;
}
.remaining-chars.warn {
  color: #e67e22;
}
.remaining-chars.error {
  color: #e74c3c;
  font-weight: 600;
}

/* ====================== IMAGE ====================== */

.form-image {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Контейнер */
.image-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
}

.image-preview {
  width: 100%;
  display: block;
  border-radius: 10px;
}

/* Оверлей */
.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.45);
  color: white;
  font-weight: 600;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.25s ease;
  border-radius: 10px;
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

/* Текст */
.replace-text {
  padding: 8px 14px;
  background: rgba(255,255,255,0.25);
  backdrop-filter: blur(3px);
  border-radius: 8px;
}

/* ====================== BUTTONS ====================== */

.form-buttons {
  margin-top: 12px;
  border-left: 3px solid #2ecc71;
  padding-left: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-buttons-text {
  padding: 9px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
}

.btn-add-button {
  margin-top: 8px;
  padding: 8px 12px;
  background: #f7f9fc;
  border: 1px solid #d5dce5;
  border-radius: 6px;
  cursor: pointer;
}

.btn-add-button:hover {
  background: #eef3fa;
}

/* ====================== MODAL ACTIONS ====================== */

.modal-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
}

.btn-primary {
  padding: 10px 16px;
  background: #2ecc71;
  border-radius: 8px;
  font-weight: 600;
  color: white;
  cursor: pointer;
}

.btn-primary:disabled {
  background: #8cd6ad;
  cursor: not-allowed;
}

.btn-secondary {
  padding: 10px 16px;
  background: #ececec;
  border-radius: 8px;
  cursor: pointer;
}

/* ====================== VALIDATION ERRORS ====================== */

.form-errors {
  background: #ffe9e9;
  padding: 10px 14px;
  border-left: 3px solid #e74c3c;
  border-radius: 6px;
  margin-top: -6px;
}

.form-errors p {
  margin: 4px 0;
  font-size: 14px;
  color: #c0392b;
}

/* ====================== ADD BOT BUTTON ====================== */

.btn-add {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #2980b9;
  color: white;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;
  transition: 0.2s;
}

.btn-add:hover {
  background: #1f6fa3;
}

/* когда изображения нет */
.image-empty {
  width: 100%;
  height: 180px;
  background: #f3f4f7;
  border: 2px dashed #c4c9d3;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.2s ease;
}

.image-empty:hover {
  background: #e9eef4;
  border-color: #9ea5b3;
}

.image-empty-text {
  color: #6b7480;
  font-size: 15px;
  font-weight: 600;
}

/* когда изображение есть */
.image-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;
  border-radius: 10px;
  overflow: hidden;
}

.image-preview {
  width: 100%;
  display: block;
  border-radius: 10px;
}

/* оверлей */
.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.45);
  color: white;
  font-weight: 600;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: 0.25s ease;
  border-radius: 10px;
}

.image-wrapper:hover .image-overlay {
  opacity: 1;
}

.replace-text {
  padding: 8px 14px;
  background: rgba(255,255,255,0.25);
  backdrop-filter: blur(3px);
  border-radius: 8px;
}

</style>


